import i18next from 'i18next'
import * as Yup from 'yup'
import { noteFields } from './fields'

export const noteValidation = (data) => {
    const { t } = i18next
    const maxCharacters = 1000

    return {
        initialValues: {
            [noteFields.NOTE_TITLE]: data?.noteTitle ?? '',
            [noteFields.NOTE_DATE]: data?.noteDate ?? '',
            [noteFields.NOTE]: data?.note ?? '',
            [noteFields.NOTE_AGENT_ID]: data?.agent?.id,
        },
        validationSchema: Yup.object({
            [noteFields.NOTE_TITLE]: Yup.string().required(t('modal.notes.error.title')),
            [noteFields.NOTE_DATE]: Yup.string().required(t('modal.notes.error.date')),
            [noteFields.NOTE]: Yup.string()
                .required(t('modal.notes.error.note'))
                .max(maxCharacters, t('modal.notes.error.limit', { maxCharacters })),
            [noteFields.NOTE_AGENT_ID]: Yup.string().required(t('modal.notes.error.agent')),
        }),
    }
}
